module.exports = __webpack_public_path__ + "r-v3/img/new_window_white.b9f8312f.svg";